(function () {
  if (typeof window.getVidalyticsPlayer !== 'function') {
    (function (v, a, p, i) {
      v.getVidalyticsPlayer = function (n) {
        v[a] = v[a] || {};
        v[a][p] = v[a][p] || {};
        var d = (v[a][p][n] = v[a][p][n] || {});
        return new Promise(function (resolve) {
          if (d[i]) {
            resolve(d[i]);
            return;
          }
          var t;
          Object.defineProperty(d, i, {
            get: function () {
              return t;
            },
            set: function (val) {
              t = val;
              resolve(val);
            }
          });
        });
      };
    })(window, '_vidalytics', 'embeds', 'player');
  }

  function loadVidalyticsEmbed(embedId, embedPath) {
    if (!embedId || !embedPath || !document.getElementById(embedId)) return;

    (function (v, i, d, a, l, y, t, c, s) {
      y = '_' + d.toLowerCase();
      c = d + 'L';
      if (!v[d]) v[d] = {};
      if (!v[c]) v[c] = {};
      if (!v[y]) v[y] = {};
      var vl = 'Loader';
      var vli = v[y][vl];
      var vsl = v[c][vl + 'Script'];
      var vlf = v[c][vl + 'Loaded'];
      var ve = 'Embed';
      if (!vsl) {
        vsl = function (u, cb) {
          if (t) {
            cb();
            return;
          }
          s = i.createElement('script');
          s.type = 'text/javascript';
          s.async = 1;
          s.src = u;
          if (s.readyState) {
            s.onreadystatechange = function () {
              if (s.readyState === 'loaded' || s.readyState == 'complete') {
                s.onreadystatechange = null;
                vlf = 1;
                cb();
              }
            };
          } else {
            s.onload = function () {
              vlf = 1;
              cb();
            };
          }
          i.getElementsByTagName('head')[0].appendChild(s);
        };
      }
      v[c][vl + 'Script'] = vsl;
      vsl(l + 'loader.min.js', function () {
        if (!vli) {
          var vlc = v[c][vl];
          vli = new vlc();
          v[y][vl] = vli;
        }
        vli.loadScript(l + 'player.min.js', function () {
          var vec = v[d][ve];
          t = new vec();
          t.run(a);
        });
      });
    })(window, document, 'Vidalytics', embedId, embedPath);
  }

  class TailwindVidalyticsDcm {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.sectionEl = document.getElementById('shopify-section-' + this.sectionId);
      this.storageKey = 'dcm-vidalytics-unlock-' + window.location.pathname.replace(/\W/g, '');
      this.revealAnchor = root.dataset.revealAnchor || 'product-selector-anchor-link';
      this.scrollOnReveal = root.dataset.scrollOnReveal === 'true';
      this.enableAutoReveal = root.dataset.enableAutoReveal === 'true';
      this.autoRevealDelay = parseInt(root.dataset.autoRevealDelay || '0', 10);
      this.scrollOnAutoReveal = root.dataset.scrollOnAutoReveal === 'true';
      this.enableFallback = root.dataset.enableFallback === 'true';
      this.fallbackDelay = parseInt(root.dataset.fallbackDelay || '0', 10);
      this.desktopEmbedId = root.dataset.desktopEmbedId;
      this.mobileEmbedId = root.dataset.mobileEmbedId;
      this.desktopEmbedPath = root.dataset.desktopEmbedPath;
      this.mobileEmbedPath = root.dataset.mobileEmbedPath;
      this.fallbackButton = root.querySelector('[data-dcm-fallback-button]');
      this.unlocked = false;
      this.playTimerStarted = false;
      this.pageLoadFallbackTimer = null;
      this.autoRevealTimer = null;
      this.fallbackButtonTimer = null;

      this.unlock = this.unlock.bind(this);
      this.onHashChange = this.onHashChange.bind(this);
      this.onFallbackClick = this.onFallbackClick.bind(this);
    }

    init() {
      if (!this.sectionEl) return;

      this.loadActiveEmbed();
      this.bindFallbackButton();
      this.bindHashListeners();

      // Theme editor / visual preview: keep all sections visible so merchants can edit.
      if (this.isDesignMode()) {
        this.unlock({ scroll: false });
        this.showFallbackButton();
        return;
      }

      if (this.isAlreadyUnlocked() || this.hasRevealHash() || this.isPageReload()) {
        this.unlock({ scroll: this.hasRevealHash() && this.scrollOnReveal });
        return;
      }

      this.hideBelow();
      this.bindPlayers();

      if (this.enableFallback && this.fallbackDelay > 0) {
        this.pageLoadFallbackTimer = window.setTimeout(() => {
          if (!this.playTimerStarted) {
            this.showFallbackButton();
          }
        }, this.fallbackDelay * 1000);
      }
    }

    isDesignMode() {
      return Boolean(
        window.Shopify &&
          (window.Shopify.designMode || window.Shopify.visualPreviewMode)
      );
    }

    isPageReload() {
      try {
        var nav = window.performance && window.performance.getEntriesByType
          ? window.performance.getEntriesByType('navigation')[0]
          : null;
        if (nav && nav.type) {
          return nav.type === 'reload';
        }
        // Legacy fallback
        return (
          window.performance &&
          window.performance.navigation &&
          window.performance.navigation.type === 1
        );
      } catch (e) {
        return false;
      }
    }

    isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    loadActiveEmbed() {
      var mobile = this.isMobile();
      var embedId = mobile ? this.mobileEmbedId : this.desktopEmbedId;
      var embedPath = mobile ? this.mobileEmbedPath : this.desktopEmbedPath;
      // window.vidalyticsDefer exists only when the section has a poster; otherwise start now.
      (window.vidalyticsDefer || function (fn) { fn(); })(function () {
        loadVidalyticsEmbed(embedId, embedPath);
      });
    }

    activeEmbedId() {
      return this.isMobile() ? this.mobileEmbedId : this.desktopEmbedId;
    }

    bindPlayers() {
      var embedIds = [this.desktopEmbedId, this.mobileEmbedId].filter(Boolean);
      var uniqueIds = embedIds.filter(function (id, index, arr) {
        return arr.indexOf(id) === index;
      });

      uniqueIds.forEach((embedId) => {
        // Only attach to embeds that exist in the DOM (active breakpoint).
        if (!document.getElementById(embedId)) return;

        window.getVidalyticsPlayer(embedId).then((player) => {
          if (!player) return;

          player.on('cta:click', () => {
            this.unlock({ scroll: this.scrollOnReveal });
          });

          player.on('play', () => {
            this.startTimersFromPlay();
          });
        });
      });
    }

    startTimersFromPlay() {
      if (this.playTimerStarted || this.unlocked) return;
      if (!this.enableAutoReveal && !this.enableFallback) return;

      this.playTimerStarted = true;

      if (this.pageLoadFallbackTimer) {
        window.clearTimeout(this.pageLoadFallbackTimer);
        this.pageLoadFallbackTimer = null;
      }

      if (this.enableAutoReveal) {
        this.autoRevealTimer = window.setTimeout(() => {
          this.autoRevealTimer = null;
          if (!this.unlocked) {
            this.unlock({ scroll: this.scrollOnAutoReveal });
          }
        }, Math.max(this.autoRevealDelay, 0) * 1000);
      }

      if (this.enableFallback) {
        this.fallbackButtonTimer = window.setTimeout(() => {
          this.fallbackButtonTimer = null;
          this.showFallbackButton();
        }, Math.max(this.fallbackDelay, 0) * 1000);
      }
    }

    showFallbackButton() {
      if (!this.enableFallback || !this.fallbackButton || this.unlocked) return;
      this.fallbackButton.classList.remove('hidden');
      this.fallbackButton.setAttribute('aria-hidden', 'false');
    }

    bindFallbackButton() {
      if (!this.fallbackButton) return;
      this.fallbackButton.addEventListener('click', this.onFallbackClick);
    }

    onFallbackClick(event) {
      event.preventDefault();
      this.unlock({ scroll: this.scrollOnReveal });
    }

    bindHashListeners() {
      window.addEventListener('hashchange', this.onHashChange);
    }

    onHashChange() {
      if (this.hasRevealHash()) {
        this.unlock({ scroll: this.scrollOnReveal });
      }
    }

    hasRevealHash() {
      var hash = (window.location.hash || '').replace(/^#/, '');
      return hash !== '' && hash === this.revealAnchor;
    }

    isAlreadyUnlocked() {
      try {
        return window.sessionStorage.getItem(this.storageKey) === '1';
      } catch (e) {
        return false;
      }
    }

    persistUnlock() {
      try {
        window.sessionStorage.setItem(this.storageKey, '1');
      } catch (e) {
        // Ignore storage failures (private mode, etc.)
      }
    }

    hideBelow() {
      var sibling = this.sectionEl.nextElementSibling;
      while (sibling) {
        if (sibling.id && sibling.id.indexOf('shopify-section-') === 0) {
          sibling.classList.add('dcm-reveal-hidden');
        }
        sibling = sibling.nextElementSibling;
      }
      document.documentElement.classList.add('dcm-content-locked');
      document.documentElement.classList.remove('dcm-content-unlocked');
    }

    showBelow() {
      var sibling = this.sectionEl.nextElementSibling;
      while (sibling) {
        sibling.classList.remove('dcm-reveal-hidden');
        sibling = sibling.nextElementSibling;
      }
      document.documentElement.classList.remove('dcm-content-locked');
      document.documentElement.classList.add('dcm-content-unlocked');
    }

    unlock(options) {
      options = options || {};
      if (this.unlocked) {
        if (options.scroll) this.scrollToAnchor();
        return;
      }

      this.unlocked = true;
      this.persistUnlock();
      this.showBelow();

      if (this.autoRevealTimer) {
        window.clearTimeout(this.autoRevealTimer);
        this.autoRevealTimer = null;
      }

      if (this.fallbackButtonTimer) {
        window.clearTimeout(this.fallbackButtonTimer);
        this.fallbackButtonTimer = null;
      }

      if (this.fallbackButton) {
        this.fallbackButton.classList.add('hidden');
        this.fallbackButton.setAttribute('aria-hidden', 'true');
      }

      if (options.scroll) {
        window.requestAnimationFrame(() => {
          this.scrollToAnchor();
        });
      }
    }

    scrollToAnchor() {
      var target = document.getElementById(this.revealAnchor);
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-vidalytics-dcm]').forEach(function (root) {
      if (root.dataset.dcmInitialized === 'true') return;
      root.dataset.dcmInitialized = 'true';
      new TailwindVidalyticsDcm(root).init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
